module.exports = __webpack_public_path__ + "static/img/tree.41664da8.svg";